export const UPDATE_COLUMNS = 'UPDATE_COLUMNS'
export const UPDATE_SHOWN_COLUMNS = 'UPDATE_SHOWN_COLUMNS'
export const UPDATE_HIDDEN_COLUMNS = 'UPDATE_HIDDEN_COLUMNS'
export const RESET_COLUMNS = 'RESET_COLUMNS'
export const UPDATE_SHOW_SUB_TABLE = 'UPDATE_SHOW_SUB_TABLE'
